import { useState, useEffect, useRef } from 'react';
import { BiRevision } from "react-icons/bi";
import './style.css';
import { getAllSubContableAcounts } from '../../../usecases/contable-acounts-usecase'; // Import the use case
import SearchDropdown from '../../atoms/searchdropdown/view';

const SubaccountSearchDropdown = ({ onSelected, selected = undefined }) => {

  const [allSubaccounts, setAllSubaccounts] = useState([]); // State to store fetched subaccounts
  const [loading, setLoading] = useState(true);
  const [reloading, setReloading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubaccounts = async (force = false) => {
    try {
      if (force) {
        setReloading(true);
      } else {
        setLoading(true);
      }

      setError(null);
      const fetchedSubaccounts = await getAllSubContableAcounts("", "", force);
      const cleanSubaccounts = (fetchedSubaccounts || []).filter(item => item && item.message !== 'empty_array');
      setAllSubaccounts(cleanSubaccounts.map(item => {
        const paddedCode = String(item.code ?? '').padStart(2, '0');
        
        // Obtener el código de la cuenta base (account) y su descripción (description) de forma segura
        const baseAccountObj = item.base_account || item.account_info;
        const baseAccount = baseAccountObj?.account || '';
        const subDescription = item.description || '';
        
        const accountPath = baseAccount ? `${baseAccount}${paddedCode}` : paddedCode;
        const displayName = subDescription ? `${accountPath} - ${subDescription}` : accountPath;
        
        return {
          ...item,
          name: displayName
        }
      }));
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
      setReloading(false);
    }
  };

  useEffect(() => {
    fetchSubaccounts();
  }, []);

  if (loading) {
    return <div className="subaccount-search-dropdown">Cargando subcuentas...</div>;
  }

  if (error) {
    return <div className="subaccount-search-dropdown" style={{ color: 'red' }}>Error: {error.message}</div>;
  }

  const matchAccount = (itm) => {
    if (!selected) return false;

    // users_accounts_id es el FK canónico al subaccount (campo más confiable)
    if (selected.users_accounts_id != null) {
      return Number(itm.id) === Number(selected.users_accounts_id);
    }

    // Fallback: buscar por user_account.id (cuando viene del estado local tras el merge)
    if (selected.user_account?.id != null) {
      return Number(itm.id) === Number(selected.user_account.id);
    }

    // Último fallback: sub_account_id
    if (selected.sub_account_id != null) {
      return Number(itm.id) === Number(selected.sub_account_id);
    }

    return false;
  };

  const handleSelectPlaceholder = () => {
    if (selected) {
      const matched = allSubaccounts.find(matchAccount);
      return matched ? matched.name : 'Selecciona una opcion';
    }
    return 'Selecciona una opcion';
  }

  const getSelectedValue = () => {
    if (selected) {
      const matched = allSubaccounts.find(matchAccount);
      return matched ? matched.name : '';
    }
    return '';
  };



  return (
    <SearchDropdown
      placeholder={handleSelectPlaceholder()}
      options={allSubaccounts}
      path='name'
      onSelect={onSelected}
      forceReload={() => fetchSubaccounts(true)}
      value={getSelectedValue()}
    />
  );
};

export default SubaccountSearchDropdown;
